import React, { useEffect } from 'react';
import { clsx } from 'clsx';

// Import real tracking functions from mi-ui-library
// eslint-disable-next-line @nx/enforce-module-boundaries
import { TrackingPropsInterface, constants, getClickTrackValue, trackImpression } from '@marriott/mi-ui-library';

export interface UseTrackingParameters {
  ref: React.RefObject<HTMLElement>;
  trackingProperties?: TrackingPropsInterface;
  isExternal?: boolean;
  custom_click_track_value?: string;
  preTrackVal?: string;
  text?: string;
}

export function useTracking({
  ref,
  trackingProperties = {},
  isExternal = false,
  custom_click_track_value = '',
  preTrackVal = '',
  text = '',
}: UseTrackingParameters) {
  useEffect(() => {
    const {
      clickTrack = false,
      impressionTrack = false,
      impressionCount = false,
      isDCAEnabled = false,
      trackingContentPosition = '',
      trackingDescription = '',
      trackingOfferType = '',
      trackingTag = '',
      atCCeVar48 = '',
      compName = '',
      additionalTrackingVariables = '',
      merchandisingCategory = '',
    } = trackingProperties;

    const shouldEnableTracking = clickTrack || impressionTrack || custom_click_track_value.trim().length;
    const isTrackingComplete = ref?.current?.classList?.contains('track-completed');

    if (!shouldEnableTracking || isTrackingComplete || !ref?.current) {
      return;
    }

    Object.assign(ref.current.dataset, {
      isCoBrand: merchandisingCategory === constants.COBRAND_NON_POINTS_MATH,
      isImpressionTrack: impressionTrack,
      isClickTrack: clickTrack,
      trackingContentPosition,
      trackingDescription,
      trackingOfferType,
      trackingTag,
      atCCeVar48,
      compName,
      impressionCount,
      additionalTrackingVariables,
      isDCAEnabled,
      custom_click_track_value,
    });

    ref.current?.classList?.add(
      ...clsx(clickTrack && 'custom_click_track', !impressionTrack && 'no-impression').split(' ')
    );
    if (!custom_click_track_value) {
      getClickTrackValue(isExternal ? 'external' : 'internal', trackingProperties, ref);
    }
    if (impressionTrack) {
      trackImpression(trackingProperties, text, preTrackVal);
    }
    ref.current?.classList?.add('track-completed');
  }, [ref, trackingProperties, isExternal, custom_click_track_value, preTrackVal, text]);
}
